const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});

export const INVOICE_LIST = asyncActionType('aerosimple/settings/INVOICE_LIST');
export const INVOICE_DETAIL = asyncActionType('aerosimple/settings/INVOICE_DETAIL');
export const EXPORT_INVOICE = asyncActionType('aerosimple/settings/EXPORT_INVOICE');
export const DO_PAYMENT = asyncActionType('aerosimple/settings/DO_PAYMENT');
export const INVOICE_GET_SCHEMA = asyncActionType('aerosimple/settings/INVOICE_GET_SCHEMA');
